import { LayoutGrid, LayoutGridCell } from '@llt-frontend/react-material-layout-grid';
import { CircularProgress } from '@llt-frontend/react-material-progress';
import columnSpans from '@llt-frontend/react-material-layout-grid/dist/constants/column-spans';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import PackageTile from './package-tile';
import PromotionBanner from './promotion-banner';
import PropTypes from 'prop-types';
import React from 'react';

import MEDIA_QUERIES from '../../constants/media-queries.json';

function _getMaxDiscount(packages) {
  const savedAmounts = packages.map(({ offer_listings }) => {
    return offer_listings && offer_listings.length > 0 ? offer_listings[0].amount_saved.amount : 0;
  });

  return Math.max(...savedAmounts);
}

function PackageTiles({ loading, packages, promotion }) {
  const renderFourColumnGrid = useMediaQuery(MEDIA_QUERIES.fourColumnGrid);
  const { t, ready: translationLoaded } = useTranslation('self-service/packages/package-tiles');

  if (loading || !translationLoaded) {
    return (
      <div className="package-tiles__progress">
        <span className="progress__spinner">
          <CircularProgress />
        </span>
      </div>
    );
  }

  if (!packages) {
    return null;
  }

  return (
    <>
      {packages.length > 0 && promotion && (
        <PromotionBanner endDate={promotion.ends_at} maxSavings={_getMaxDiscount(packages)} />
      )}
      <LayoutGrid className="package-tiles">
        {packages.length === 0 ? (
          <LayoutGridCell columnSpan={columnSpans.full}>
            <p className="package-tiles__no-packages">{t('noPackages')}</p>
          </LayoutGridCell>
        ) : (
          <>
            {packages.map((pkg, position) => (
              <LayoutGridCell
                key={position}
                columnSpan={renderFourColumnGrid ? columnSpans.oneThird : columnSpans.oneQuarter}
              >
                <PackageTile {...{ position, ...pkg }} />
              </LayoutGridCell>
            ))}
          </>
        )}
      </LayoutGrid>
    </>
  );
}

PackageTiles.propTypes = {
  loading: PropTypes.bool,
  packages: PropTypes.arrayOf(PropTypes.object),
  promotion: PropTypes.object,
};

export default PackageTiles;
